module.exports = __webpack_public_path__ + "static/img/chobi.32d8d38.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/chobi.png
// module id = TGk2
// module chunks = 0